module.exports = __webpack_public_path__ + "img/tech_how_it_works.661b8814.png";